module.exports = __webpack_public_path__ + "img/p_sz_16.23d27d19.svg";